"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var ErrorFallback = function ErrorFallback(_ref) {
  var error = _ref.error,
      resetErrorBoundary = _ref.resetErrorBoundary;
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Something went wrong:"), /*#__PURE__*/_react.default.createElement("pre", null, error.message), /*#__PURE__*/_react.default.createElement("button", {
    onClick: resetErrorBoundary
  }, "Try again"));
};

var _default = ErrorFallback;
exports.default = _default;